import React from "react";
import {
  Card,
  CardContent,
  Typography,
  Grid,
} from "@mui/material";
import { Psychology as SkillsIcon } from "@mui/icons-material";
import CustomSelect from "../FormFields/CustomSelect/CustomSelect";
import CustomInput from "../FormFields/CustomInput/CustomInput";
import CardHeaderComponent from "./CardHeaderComponent";
import { tempOrPermOptions } from "./CandidateForm.Config";

const CandidateSkillForm = ({ handleChange, formData }) => {
  const tempOrPermOptionsFormatted = tempOrPermOptions.map((item) => ({
    value: item.value,
    label: item.name || item.value,
  }));

  return (
    <Card
      variant="outlined"
      sx={{
        height: '100%',
        borderRadius: 2,
        borderColor: '#e2e8f0',
        boxShadow: '0 1px 3px rgba(0,0,0,0.04)',
        overflow: 'hidden',
      }}
    >
      <CardHeaderComponent icon={SkillsIcon} title="Skills" />
      <CardContent sx={{ p: 2.5 }}>
        <Grid container spacing={2}>
          <Grid size={{ xs: 12 }}>
            <CustomInput
              label="Current Employer"
              name="current_employer"
              onChange={handleChange}
              value={formData?.current_employer || ""}
              fullWidth
              size="small"
              placeholder="Enter current employer"
            />
          </Grid>
          
          <Grid size={{ xs: 12 }}>
            <CustomSelect
              options={tempOrPermOptionsFormatted}
              label="Temp or Perm"
              name="temp_or_perm"
              onChange={handleChange}
              value={formData?.temp_or_perm || ""}
              placeholder="Select Type"
              fullWidth
              size="small"
            />
          </Grid>
          
          <Grid size={{ xs: 12 }}>
            <CustomInput
              label="Skill 1"
              name="skill_1"
              onChange={handleChange}
              value={formData?.skill_1 || ""}
              fullWidth
              size="small"
              placeholder="Enter primary skill"
            />
          </Grid>
          
          <Grid size={{ xs: 12 }}>
            <CustomInput
              label="Shifts"
              name="shifts"
              onChange={handleChange}
              value={formData?.shifts || ""}
              fullWidth
              size="small"
              placeholder="Enter shift availability"
            />
          </Grid>
          
          <Grid size={{ xs: 12 }}>
            <CustomInput
              label="Equal Opportunities"
              name="equal_opportunities"
              onChange={handleChange}
              value={formData?.equal_opportunities || ""}
              fullWidth
              size="small"
              placeholder="Enter equal opportunities information"
            />
          </Grid>
          
          <Grid size={{ xs: 12 }}>
            <CustomInput
              label="Other area or speciality"
              name="other_area_or_speciality"
              onChange={handleChange}
              value={formData?.other_area_or_speciality || ""}
              fullWidth
              size="small"
              placeholder="Enter other areas or specialities"
            />
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
};

export default CandidateSkillForm;